import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { HelpCircle } from 'lucide-react';

const faqs = [
  {
    q: "Combien de temps faut-il pour créer mon site web ?",
    a: "La plupart des sites sont livrés sous 7 jours après validation du devis et réception des éléments nécessaires (logo, textes, photos, etc.).",
  },
  {
    q: "Mon site sera-t-il adapté aux smartphones ?",
    a: "Oui. Tous les sites Créaprestige sont entièrement optimisés pour les smartphones, tablettes et ordinateurs.",
  },
  {
    q: "Pourrai-je modifier mon site par la suite ?",
    a: "Oui. Selon la solution choisie, vous pourrez modifier certains contenus.",
  },
  {
    q: "Que comprend la maintenance mensuelle ?",
    a: "La maintenance inclut l'hébergement, les mises à jour techniques, les sauvegardes régulières, la sécurité du site et une assistance en cas de besoin.",
  },
  {
    q: "Que se passe-t-il si j'ai besoin d'aide après la mise en ligne ?",
    a: "Nous restons disponibles pour vous accompagner. Vous bénéficiez d'un support réactif pour répondre à vos questions et assurer le bon fonctionnement de votre site.",
  },
  {
    q: "Dois-je payer la totalité du projet avant le début ?",
    a: "Non. Un acompte est demandé pour démarrer le projet, puis le solde est réglé avant la mise en ligne du site.",
  },
  {
    q: "Mon site sera-t-il visible sur Google ?",
    a: "Oui. Tous nos sites sont conçus selon les bonnes pratiques de référencement afin de faciliter leur indexation par Google.",
  },
  {
    q: "Puis-je demander des modifications pendant la création ?",
    a: "Bien sûr. Des ajustements sont prévus pendant le développement afin que le résultat corresponde parfaitement à vos attentes.",
  },
  {
    q: "Que faire si je n'ai pas de logo ou de contenu ?",
    a: "Aucun problème. Nous pouvons vous conseiller et vous accompagner pour préparer les textes, images et éléments nécessaires à votre projet.",
  },
  {
    q: "Pourquoi choisir Créaprestige ?",
    a: "Parce que nous proposons des sites modernes, rapides et professionnels, livrés sous 7 jours, avec un accompagnement personnalisé et une maintenance assurée pour vous permettre de vous concentrer sur votre activité.",
  },
];

const FaqSection = () => {
  return (
    <section id="faq" className="py-20 lg:py-32 bg-gray-950 border-t border-gray-800" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-orange-500/20 rounded-full px-4 py-2 mb-6">
            <HelpCircle className="w-4 h-4 text-orange-400" />
            <span className="text-sm font-semibold text-orange-400 uppercase tracking-wide">Questions fréquentes</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Questions fréquentes
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Tout ce que vous devez savoir avant de lancer votre projet web.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((item, index) => (
            <AccordionItem
              key={item.q}
              value={`item-${index}`}
              data-testid={`faq-item-${index}`}
              className="border border-gray-700 rounded-xl bg-gray-900 px-6 transition-colors hover:border-orange-400/50"
            >
              <AccordionTrigger className="text-left text-lg font-semibold text-white hover:no-underline py-5 [&>svg]:text-orange-400">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-gray-400 leading-relaxed">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
